import React from 'react';
import { connect } from 'react-redux';
import Cell from '../components/Scheduler/HeaderCell'

const mapStateToProps = state => ({
    rowTitlePosition: state.rowTitlePosition,
});

const CellContainer = ({rowTitlePosition, rowSpan, position, content}) => {
    return (
        <Cell
            rowTitlePosition={rowTitlePosition}
            rowSpan={rowSpan}
            position={position}
            content={content}
        />
    )
};

export default connect(
    mapStateToProps,
)(CellContainer)